export default {
	tabs: ["Withdraw", "History"],
	History: {
		tabs: ["Reviewing", "Success", "Reject"]
	},
	Withdraw: {
		label: ["Account Number", "Order No", "Address", "Amount", "Fee", "Created At", "Status", "Reason"]
	},
	AccountAmount: "Account Amount",
	tips: "You will receive your withdrawal within an hour ",
	form: {
		label: ["Withdraw Amount", "Transaction Password"],
		ALL: "ALL",
		Withdraw: "Submit"
	},
	WithdrawAccount: "Withdraw Account",
	noAccountsTips: "Please add Payment Methods",
	tradingKind: [
		"Cash back",
		"Deduction",
		"Recharge",
		"Withdrawing",
		"Withdrawal unfreeze",
		"Withdrawal",
		"Task",
		"Principal return",
		"Commission return",
		"Subordinate commission return",
		"Check-in",
		"Handling fee",
		"Deposit",
		"Reward",
		"Base salary",
		"Cash assistance",
		"Registration bonus",
		"Commodity dividends",
		"Task bonus",
		"Others",
		"",
		"Work bonus",
		"Upgrade Rewards",
		"Subsidy",
		"Pending Verification",
		"Campaign",
		"Points redemption",
		"Login Rewards",
		"Work Rewards",
		"Credit score transaction"
	]
};
